import { apiClient } from './client';
import type {
  CheckIdResponse,
  PerusahaanDetail,
  PerusahaanSummary,
  RegisterPerusahaanRequest,
  RegisterPerusahaanResponse,
} from '../types/api';

export const perusahaanApi = {
  checkId: (id: string) =>
    apiClient.get<CheckIdResponse>(`/perusahaan/check-id?id=${encodeURIComponent(id)}`, true),

  register: (body: RegisterPerusahaanRequest) =>
    apiClient.post<RegisterPerusahaanResponse>('/perusahaan/register', body, true),

  mine: () => apiClient.get<PerusahaanSummary[]>('/perusahaan/mine', true),

  detail: (idPerusahaan: string) =>
    apiClient.get<PerusahaanDetail>(`/perusahaan/${encodeURIComponent(idPerusahaan)}`, true),
};
